<div mat-dialog-content fxLayout="row" fxLayoutAlign="space-between start">
  <div fxFlex="49">
    <!-- AnyDate -->
    <mat-label><b>Fecha de observación</b></mat-label>
    <br />
    <mat-slide-toggle
      (change)="fnSelected('fAnyDate', $event)"
      [(ngModel)]="localData.p_any_date"
      >Cualquier fecha</mat-slide-toggle
    >
    <br />
    <!-- One date -->
    <span>Fecha exacta</span>
    <mat-form-field
      appearance="outline"
      matBadge="{{ this.localData.p_date_exactly ? 1 : null }}"
    >
      <mat-label>YYYY-MM-DD</mat-label>
      <input
        matInput
        type="text"
        [matDatepicker]="pickerDate"
        [(ngModel)]="localData.p_date_exactly"
        (dateChange)="fnSelected('fDate', $event)"
      />
      <mat-datepicker-toggle
        matSuffix
        [for]="pickerDate"
      ></mat-datepicker-toggle>
      <mat-datepicker #pickerDate color="primary"></mat-datepicker>
    </mat-form-field>
    <!-- Interval date -->
    <span>Periodo</span>
    <div fxLayout="row" fxLayoutAlign="space-between center">
      <mat-form-field
        appearance="outline"
        fxFlex="49"
        matBadge="{{ this.localData.p_date_init ? 1 : null }}"
      >
        <mat-label>YYYY-MM-DD</mat-label>
        <input
          matInput
          type="text"
          [matDatepicker]="pickerInit"
          [(ngModel)]="localData.p_date_init"
          (dateChange)="fnSelected('fDateInit', $event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerInit"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerInit color="primary"></mat-datepicker>
      </mat-form-field>
      <mat-form-field
        appearance="outline"
        fxFlex="49"
        matBadge="{{ this.localData.p_date_end ? 1 : null }}"
      >
        <mat-label>YYYY-MM-DD</mat-label>
        <input
          matInput
          type="text"
          [matDatepicker]="pickerEnd"
          [(ngModel)]="localData.p_date_end"
          (dateChange)="fnSelected('fDateEnd', $event)"
        />
        <mat-datepicker-toggle
          matSuffix
          [for]="pickerEnd"
        ></mat-datepicker-toggle>
        <mat-datepicker #pickerEnd color="primary"></mat-datepicker>
      </mat-form-field>
    </div>
    <!-- Month -->
    <span>Meses</span>
    <mat-form-field
      appearance="outline"
      matBadge="{{ this.localData.p_month ? 1 : null }}"
    >
      <mat-label>Seleccionado</mat-label>
      <mat-select
        [(ngModel)]="localData.p_month"
        (selectionChange)="fnSelected('fSelected', $event)"
      >
        <mat-option>Ninguno</mat-option>
        <mat-option *ngFor="let month of month_selection" [value]="month.id">
          {{ month.value }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div fxFlex="49">
    <!-- Person -->
    <mat-label><b>Persona</b></mat-label>
    <mat-form-field
      appearance="outline"
      matBadge="{{ this.localData.p_username ? 1 : null }}"
    >
      <mat-label
        ><mat-icon>person</mat-icon>Nombre o identificador del
        usuario</mat-label
      >
      <input
        matInput
        type="text"
        [formControl]="formPerson"
        [matAutocomplete]="auto1"
        (change)="fnSelected('fPerson', $event)"
      />
      <!-- [matAutocomplete]="auto1" elminar-->
      <button
        *ngIf="formPerson.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="
          formPerson.setValue(null);
          fnSelected('fPerson', $event);
          updatePerson()
        "
      >
        <mat-icon>close</mat-icon>
      </button>

      <mat-autocomplete
        autoActiveFirstOption
        #auto1="matAutocomplete"
        panelWidth="18em"
        (optionSelected)="updatePerson()"
      >
        <mat-option
          *ngFor="let filteredPerson of filteredListPerson | async"
          [value]="filteredPerson.val"
          [index]="filteredPerson.id"
        >
          <div fxLayout="row" fxLayoutAlign="start center">
            <mat-icon style="font-size: 32px; color: #8b2f00"
              >account_circle</mat-icon
            >

            {{ filteredPerson.val }}
          </div>
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
    <!-- Location -->
    <mat-label><b>Lugar</b></mat-label>
    <mat-form-field
      appearance="outline"
      matBadge="{{ this.localData.p_place ? 1 : null }}"
    >
      <mat-label><mat-icon>public</mat-icon> Lugar</mat-label>
      <input
        matInput
        type="text"
        [formControl]="formSite"
        (change)="fnSelected('fSite', $event)"
      />
      <button
        *ngIf="formSite.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="formSite.setValue(null); fnSelected('fSite', $event)"
      >
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
    <!-- -------- -->
  </div>
</div>
<div mat-dialog-actions fxLayout="row" fxLayoutAlign="space-between center">
  <button mat-button color="basic" [mat-dialog-close]>Cancelar</button>
  <button mat-stroked-button color="primary" (click)="fnSearch()">
    Buscar
  </button>
</div>
